import request from "../utils/request"

// Published exam papers, written into the app's database by GE Gremlin and
// read here by the student they were written for and their parents.
//
// Read-only. There is no create, update or submit endpoint and there should
// never be one -- the student writes on their own paper and Sarah marks it;
// this is a reading surface.

export const getExams = () => request.get("/exams")

export const getExam = id => request.get(`/exams/${id}`)

// Drives the nav icon, which is hidden entirely when this is zero. Its own
// endpoint rather than a count off the list, because the header renders on
// every page and the list carries every paper's title and grade.
export const getExamCount = () => request.get("/exams/count")

/**
 * Fetch one feedback file as a blob.
 *
 * Not an <a href>. The file is served by an authenticated API route, and the
 * SPA authenticates with a Bearer token held in memory -- a plain link is a
 * browser navigation that carries no such header, so it would 401 for everyone
 * whose session cookie is not also valid on the API host.
 *
 * The blob is turned into a download by the caller; download_path comes from
 * the API, so nothing here builds a bucket URL. That matters: the feedback
 * bucket also holds world-readable question images, and the only thing keeping
 * a marked paper private is that its key never leaves the server.
 */
export const downloadExamAttachment = downloadPath => request.get(downloadPath, {}, { responseType: "blob" })
